import PurchaseTrainingCta from './PurchaseTrainingCta.vue';

export default PurchaseTrainingCta;
